import PropertyReport from "..";
const propertyReportRoute = [
  {
    path: "property-report/:pId/:reportId",
    element: <PropertyReport />,
  },
];
export default propertyReportRoute;
